export default () => {
  throw new Error(`should not be called`);
};
